import { io } from 'socket.io-client';

class socketWrapper {
    static socket = null;

    static connect() {
        if (socketWrapper.socket) return socketWrapper.socket;
        socketWrapper.socket = io(window.location.origin, {
            withCredentials: true,
            reconnectionDelayMax: 10000,
        });
        return socketWrapper.socket;
    }

    static disconnect() {
        if (socketWrapper.socket) {
            socketWrapper.socket.disconnect();
            socketWrapper.socket = null;
        }
    }
}

export { socketWrapper };
